import { UpperCasePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import * as confetti from "canvas-confetti";
import { catchError, of } from "rxjs";
import { HomeDataService } from "src/app/services/home-data.service";
@Component({
  selector: "app-voucher-dialog",
  templateUrl: "./voucher-dialog.component.html",
  styleUrls: ["./voucher-dialog.component.scss"],
  standalone: true,
  imports: [
    IonicModule,
    UpperCasePipe,
    TranslatePipe,
  ],
})
export class VoucherDialogComponent implements OnInit {
  voucherSuccessResponse = null;
  canvas_width = 1000;
  canvas_height = 1000;
  checklistVoucherStatus: boolean;
  public userId: string;
  constructor(
    private dialogRef: MatDialogRef<VoucherDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private analytics: AngularFireAnalytics,
    public translate: TranslateService,
    private authService: AuthService,
    private homeDataService: HomeDataService,
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );


    this.homeDataService?.homeCardsVM$.pipe(
      catchError((err) => {
        console.error('Error in homeCardsVM$ subscription (voucher-dialog):', err);
        return of(null);
      })
    ).subscribe(
      (res: Data) => {
        if (res && res.hasOwnProperty("new_member_checklist") && 
            res.new_member_checklist?.content?.checklist &&
            Array.isArray(res.new_member_checklist.content.checklist)) {
          const indexOne = 1;
          const checklist = res.new_member_checklist.content.checklist;
          if (checklist.length > indexOne) {
            this.checklistVoucherStatus = checklist[indexOne]?.status;
          }
        }
      },
      (error) => {
        console.error('Subscription error:', error);
        return error;
      }
    );

    //This method is used to call the confetti animation.
    this.confettiAnimation();
  }

  async ngOnInit() {
    await this.authService.getUid("VoucherDialogComponent").then((uid) => {
      this.userId = uid;
    })
    this.analytics.logEvent("voucher_success_modal", { userId: this.userId });

    // This variable contain voucher data
    this.voucherSuccessResponse = this.data;
  }

  // This method is used to close the dialog and redirect to Game page screen
  viewTickets() {
    try {
      this.dialogRef.close(true);
      if (this.checklistVoucherStatus === false) {
        this.toastMessage();
      }
    } catch (err) {
      throw new Error("Something went wrong" + err);
    }
  }

  backToVouchers() {
    this.dialogRef.close();
  }
  // This method is used to show tost messages
  async toastMessage(): Promise<void> {
    try {
      const MESSAGE_CODE = "1118";
      const translatedMsg = await this.authService.getConstantsMsg(MESSAGE_CODE);
      const defaultMsg = {
        message: {
          line_1: "Completed action",
          line_2: "Checklist steps complete!",
        },
        style: {
          icon: "tick circle success.png",
          type: "Success",
        },
      };
      // This method has been used to set toast message
      this.authService.showToastMessage(translatedMsg, defaultMsg);
    } catch (error) {
      throw new Error("Error when getting constants message" + error);
    }
  }
  //This method is used to call the confetti animation
  confettiAnimation() {
    let canvas = document.getElementById("confetti-canvas") as HTMLCanvasElement;
    // Create only once and reuse
    if (!canvas) {
      canvas = document.createElement("canvas");
      canvas.id = "confetti-canvas";
      canvas.width = this.canvas_width;
      canvas.height = this.canvas_height;
      canvas.style.zIndex = "9999";
      canvas.style.position = "absolute";
      canvas.style.pointerEvents = "none";
      document.body.appendChild(canvas);
    }
    const animation = confetti.create(canvas, { resize: true, useWorker: true });

    animation({
      particleCount: 1000,
      spread: 180,
      angle: 265,
      origin: { x: 0.8, y: -0.4 },
    });
  }
}
